<div class="bleed-surface-100 bleed-bg py-6">
  @if (showLogin()) {
    <p class="text-center font-medium text-lg">Homey</p>

    <div class="flex flex-row justify-center my-4">
      @if (user()?.status === 'unauthorized' || user()?.status === undefined) {
        <a pButton size="small" class="w-[8rem]" [routerLink]="['login']"><span pButtonLabel>Log in</span></a>
      } @else {
        <p-button size="small" styleClass="w-[8rem]" (onClick)="onLogoutClick()" label="Log out"/>
      }
    </div>
  } @else {
    <div class="mb-10">
        <h2 class="text-center font-medium text-lg mb-4">
        Featured in
      </h2>

      <div class="flex flex-row gap-4 justify-around items-center">
        <a href="https://secretnyc.co/homey-affordable-housing-app/" target="_blank" rel="noopener">
          <img
            src="/assets/landing-page/articles/secret-nyc.png"
            [attr.alt]="'Featured on: Secret NYC — This brand-new app will apply to affordable housing lotteries for you, and it’s a lifesaver.'"
            class="max-h-12 filter grayscale"
          />
        </a>
        <a
          href="https://www.timeout.com/newyork/news/this-useful-new-app-automatically-applies-for-affordable-housing-units-that-you-qualify-for-050125"
          target="_blank" rel="noopener">
          <img
            src="/assets/landing-page/articles/timeout-nyc-no-background.png"
            [attr.alt]="'Featured on: Time Out New York — This useful new app automatically applies for affordable housing units that you qualify for.'"
            class="max-h-16 grayscale"
          />
        </a>
        <a
          href="https://pix11.com/news/local-news/new-homey-app-helps-simplify-affordable-housing-lottery-application/"
          target="_blank" rel="noopener">
          <img
            src="/assets/landing-page/articles/pix11.webp"
            [attr.alt]="'Featured on: PIX11 — New Homey app helps simplify the affordable housing lottery application.'"
            class="max-h-14 grayscale"
          />
        </a>
      </div>
    </div>
  }

  <div class="flex flex-row justify-between">
  <div class="flex flex-col gap-2">
        @for (link of footerLinks(); track link) {
      <a class="text-surface-800 font-light" [routerLink]="link.link">
        {{ link.label }}
      </a>
    }
  </div>
  </div>
</div>

<div class="bleed-surface-600 bleed-bg text-white p-4 -mb-pagePadY flex flex-col items-center">
  <div class="flex flex-row gap-8">
    <a
      href="https://www.instagram.com/homeyhousingnyc/"
      target="_blank"
      [attr.aria-label]="'Instagram'"
    >
      <i class="pi pi-instagram" style="font-size: 1.2rem"></i>
    </a>
    <a
      href="https://www.linkedin.com/company/106508559/"
      target="_blank"
      [attr.aria-label]="'LinkedIn'"
    >
      <i class="pi pi-linkedin" style="font-size: 1.2rem"></i>
    </a>
  </div>

  @if (!isNative) {
    <div class="flex flex-row gap-4 mt-4">
      <a class="cursor-pointer" href="https://play.google.com/store/apps/details?id=io.myhomey.app" target="_blank" rel="noopener">
        <img
          src="/assets/images/GetItOnGooglePlay_Badge_Web_color_English.png"
          [attr.alt]="'Download on Google Play'"
          class="h-10"
        />
      </a>
      <a class="cursor-pointer" href="https://apps.apple.com/us/app/homey-nyc/id6748840051" target="_blank" rel="noopener">
        <img
          src="/assets/images/Download_on_the_App_Store_Badge.svg.png"
          [attr.alt]="'Download on the App Store'"
          class="h-10"
        />
      </a>
    </div>
  }

  <p class="text-center font-light text-sm pt-4">
    © 2026 Homey, Affordable Housing Inc.
  </p>
</div>
